export default {
  // Logo列表
  getLogoList: '/V2/Logo/list',
  // 新增Logo
  addLogo: 'V2/Logo/addLogo',
  // 编辑Logo
  editLogo: 'V2/Logo/editLogo',
  // 获取单个Logo信息
  getLogoInfo: 'V2/Logo/getLogoInfo',
  // 冻结、解冻Logo
  changeLogoState: 'V2/Logo/freezeLogo'
}



// WEBPACK FOOTER //
// ./src/api/logo.js